export default {
      id: "arrowdown2-white-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#arrowdown2-white",
      toString: function () {
        return this.url;
      }
    }